<div class="container-fluid">
<section>
    <header>
        <h1><span jhiTranslate="study.manager.title"></span>&nbsp;
            <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
        </h1>
        <div class="row col md-g">
            <div class="row col-md-4">
                <div class="col d-flex align-items-center">
                    <img src="content/images/review-list-details.png" class="image-icon-md"/>
                    <div style="padding-top: 6px;">
                        <a href jhiTranslate="study.manager.browse-link" (click)="browseStudy($event)"></a>&nbsp;
                        <span jhiTranslate="study.manager.browse-text"></span>
                    </div>
                </div>
            </div>
            <div class="col-md-8 d-flex align-items-center justify-content-end">
                    <button class="btn btn-info " jhiTranslate="study.manager.actions.new-study" data-test="startNewStudyButton"
                            *jhiHasAnyAuthority="STUDIES_CREATION_PERMISSIONS"
                             (click)="createStudy()">
                    </button>
            </div>
        </div>
    </header>

    <div class="row mt-3">
        <section class="col">
            <nav>
                <ul class="nav nav-tabs">
                    <li class="nav-item pe-1">
                        <a class="nav-link" href="#study-search" jhiTranslate="study.manager.nav.search" (click)="setSearchTabActive()"
                           [routerLink]="['study-search']" [routerLinkActive]="['active']">Search</a>
                    </li>
                    <li class="nav-item pe-1" *ngFor="let tab of tabs" role="presentation">
                        <a class="nav-link pb-0" role="tab" data-bs-toggle="tab" (click)="setActive(tab.id)"
                           [routerLink]="['study/' + tab.id]" [routerLinkActive]="['active']" [queryParams]="{ studyId: tab.id }">
                            <span class="tab-text-ellipsis" title="{{tab.name}}">{{tab.name}}</span>
                            <i class="fa fa-times close-nav-tab nav-tab-text-ellipsis" (click)="closeTab(tab)"></i>
                        </a>
                    </li>
                </ul>
                <div class="tab-content">
                    <div role="tabpanel" class="tab-pane container-fluid row" [class.active]="!hideSearchTab">
                        <jhi-study-search></jhi-study-search>
                    </div>
                    <!-- Tab panes -->
                    <div *ngFor="let tab of tabs; trackBy: trackId" role="tabpanel" class="tab-pane container-fluid row" [class.active]="tab.active" id="study-{{tab.id}}">
                        <div class="col-xs-12 col-md-12">
                            <jhi-study-summary [studyId]="tab.id"></jhi-study-summary>
                        </div>
                    </div>
                </div>
            </nav>
        </section>
    </div>
</section>
</div>
